/** SettingsTabs — shared tab bar for the Settings area (/account, /settings/sources). */
import { useLocation, useNavigate } from "react-router-dom";
import { User, Database } from "lucide-react";

export const SettingsTabs = ({ isPt }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const tabs = [
    { route: "/account", label: isPt ? "Geral" : "General", icon: User },
    { route: "/settings/sources", label: "Data Sources", icon: Database },
  ];
  return (
    <nav className="px-8 border-b border-[var(--al-border)] bg-[var(--al-card-bg)] flex items-center gap-1"
      data-testid="settings-tabs">
      {tabs.map((tb) => {
        const active = pathname === tb.route;
        const Icon = tb.icon;
        return (
          <button key={tb.route} type="button"
            data-testid={`settings-tab-${tb.route.split("/").pop()}`}
            onClick={() => navigate(tb.route)}
            className={`inline-flex items-center gap-1.5 px-4 py-2.5 text-[12.5px] font-semibold border-b-2 -mb-px transition-colors ${
              active ? "border-[#C9A24E] text-[var(--al-text)]"
                : "border-transparent text-[var(--al-text-muted)] hover:text-[var(--al-text)]"}`}>
            <Icon className="w-3.5 h-3.5" /> {tb.label}
          </button>
        );
      })}
    </nav>
  );
};
